<template>
  <b-dropdown-item
    :disabled="disabled"
    class="dropdown-item"
    test-id="al-dropdown-item"
    @click="onClick"
  >
    <slot />
  </b-dropdown-item>
</template>
<script>
import BdropdownItem from 'bootstrap-vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BdropdownItem
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>
